import React from 'react'
import "./featured.css"

const Featured = () => {
  return (
    <div className='featured'>
       <div className='featuredItem'>
       <img src="https://cf.bstatic.com/xdata/images/region/square250/66333.webp?k=ba149e36e802032cd6ec35570600fe35878c339011b88cdd9f1fd084a8ac73b6&o=" alt="" className='featureImg'></img>
      <div className="featuredTitles">
        <h1>Lake District </h1>
        <h2>532 propertie</h2>
      </div>
      
       </div>
       <div className='featuredItem'>
       <img src="https://cf.bstatic.com/xdata/images/city/square250/613095.webp?k=8caf960d96a59e284ac1518ac8777e89d17fda6572acd84dbec151f627c7bf07&o=" alt="" className='featureImg'></img>
      <div className="featuredTitles">
        <h1>London</h1>
        <h2>123 propertie</h2>
      </div>
      
       </div>
       <div className='featuredItem'>
       <img src="https://cf.bstatic.com/xdata/images/city/square250/686185.webp?k=dc6e30f60fa23f042b872ecd6d769650f89c54414ad64ea1e5e62fafef31a609&o=" alt="" className='featureImg'></img>
      <div className="featuredTitles">
        <h1>Edinburgh</h1>
        <h2>53 propertie</h2>
      </div>
      
       </div>





    </div>
  )
}

export default Featured
